import React from 'react';
import LegalPageLayout from './LegalPageLayout';

const PrivacyPolicy = () => {
  return (
    <LegalPageLayout
      title="Privacy Notice"
      intro="This notice explains how we process personal data when you visit fluxspaces.app or contact us."
      lastUpdated="5 June 2024"
    >
      <section className="flux-legal-section">
        <h2>1. Controller</h2>
        <p>
          The controller pursuant to the EU General Data Protection Regulation (GDPR) is:
          <br />
          MAROSCH UG (haftungsbeschränkt)
          <br />
          Bunzlauer Str. 8
          <br />
          80992 Munich
          <br />
          Germany
          <br />
          E-mail: <a href="mailto:ronny@fluxspaces.app">ronny@fluxspaces.app</a>
        </p>
      </section>

      <section className="flux-legal-section">
        <h2>2. Personal Data We Process</h2>
        <h3>2.1 Provision of the Website and Server Logs</h3>
        <p>
          When you access our website, the hosting provider automatically collects and
          stores information in server log files. This may include IP address, browser type
          and version, operating system, referrer URL, host name of the accessing computer,
          time of the server request, and the amount of data transferred. These data are
          necessary to provide a stable and secure service.
        </p>
        <p>
          The legal basis is Art. 6 (1) lit. f GDPR. Our legitimate interest lies in the
          technical provision, monitoring, and improvement of our website as well as the
          prevention of misuse or attacks. The data are deleted automatically once they are
          no longer required. The precise retention periods depend on the hosting provider
          and will be added once finalised.
        </p>

        <h3>2.2 Contact by E-mail</h3>
        <p>
          If you contact us by e-mail, we process the personal data you provide (e.g. name,
          e-mail address, message content) in order to respond to your enquiry. The legal
          basis is Art. 6 (1) lit. b GDPR if the request relates to a contract or its
          initiation; otherwise Art. 6 (1) lit. f GDPR. We delete enquiries once they are no
          longer required and statutory retention obligations do not apply.
        </p>

        <h3>2.3 No Analytics or Tracking</h3>
        <p>
          We currently do not deploy analytics, tracking, or marketing tools. No usage
          profiles are created and no personal data are processed for advertising purposes.
        </p>
      </section>

      <section className="flux-legal-section">
        <h2>3. Recipients of Data</h2>
        <p>
          We only disclose personal data if this is necessary to perform a contract, we are
          legally obliged to do so, or you have given your explicit consent. Where we engage
          external service providers (processors), we bind them by contract in accordance
          with Art. 28 GDPR. Details of processors and hosting locations will be added as
          soon as the relevant agreements are in place.
        </p>
      </section>

      <section className="flux-legal-section">
        <h2>4. International Data Transfers</h2>
        <p>
          We currently do not transfer personal data to countries outside the European Union
          or the European Economic Area. Should this change, we will provide information
          about recipients and safeguards pursuant to Art. 44 et seq. GDPR.
        </p>
      </section>

      <section className="flux-legal-section">
        <h2>5. Data Security</h2>
        <p>
          We implement technical and organisational security measures to protect your data
          against loss, manipulation, or unauthorised access. This includes encrypted
          connections (HTTPS) and access controls for internal systems. We review and adapt
          these measures on a regular basis.
        </p>
      </section>

      <section className="flux-legal-section">
        <h2>6. Your Rights</h2>
        <p>You have the following rights with regard to your personal data:</p>
        <ul>
          <li>Right of access (Art. 15 GDPR)</li>
          <li>Right to rectification (Art. 16 GDPR)</li>
          <li>Right to erasure (Art. 17 GDPR)</li>
          <li>Right to restriction of processing (Art. 18 GDPR)</li>
          <li>Right to data portability (Art. 20 GDPR)</li>
          <li>Right to object (Art. 21 GDPR)</li>
        </ul>
        <p>
          Please address your requests to{' '}
          <a href="mailto:ronny@fluxspaces.app">ronny@fluxspaces.app</a>. You also have the
          right to lodge a complaint with a supervisory authority. The competent authority
          for Bavaria is the Bavarian State Office for Data Protection Supervision (BayLDA).
        </p>
      </section>

      <section className="flux-legal-section">
        <h2>7. Obligation to Provide Data</h2>
        <p>
          You are not legally or contractually obliged to provide personal data. However,
          the processing of the technical data mentioned in section 2.1 is necessary to make
          the website available. If you contact us, we require at least your e-mail address
          to respond.
        </p>
      </section>

      <section className="flux-legal-section">
        <h2>8. Changes to this Privacy Notice</h2>
        <p>
          We may update this privacy notice to reflect legal requirements or changes to our
          services. The current version applies to your next visit.
        </p>
      </section>
    </LegalPageLayout>
  );
};

export default PrivacyPolicy;
